import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FeaturedArray } from "./commonData";
import { Link } from "react-router-dom";

const NextArrow = ({ onClick }) => (
  <div
    style={{ position: "absolute", right: 0, top: "30%", cursor: "pointer", zIndex: 1 }}
    onClick={onClick}
  >
     <img src="https://www.iconpacks.net/icons/2/free-arrow-right-icon-3098-thumb.png" style={{width:"30px"}} />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div
    style={{ position: "absolute", left: 0, top: "30%", cursor: "pointer", zIndex: 1 }}
    onClick={onClick}
  >
<img src="https://www.iconpacks.net/icons/2/free-arrow-left-icon-3099-thumb.png" style={{width:"30px"}} />
  </div>
);

const CategoryCarousel = ({ categoryList }) => {
  const images = categoryList || [];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1200, // screens <= 1200px
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992, // screens <= 992px (tablet landscape)
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768, // screens <= 768px (tablet portrait)
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576, // screens <= 576px (mobile)
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400, // very small devices
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
};


  return (
    <div className="category-carousel-container">
      <h6>Category you love</h6>
      <Slider {...settings}>
        {images.map((item, idx) => (
          <Link key={idx} to={`product?category=${item?.unique_slug}`}>
            <img src={item.img_url} alt={`slide-${idx}`} className="brand-logo border-full rounded"  style={{
              objectFit:"contain"
            }}/>
            <p className="brand-name">{item.title}</p>
          </Link>
        ))}
      </Slider>
    </div>
  );
};

export default CategoryCarousel;
